import { REST } from './utils';

const { GET, POST } = REST('/pdf/fullArticle');

export const getDetails = (articleId: string): Promise<{ needTocConsent: boolean; pdfUrl: string }> =>
    GET(`/${articleId}/details`);

export const tocConsent = (articleId: string): Promise<void> => POST(`/${articleId}/tocConsent`);
